const loadGoogleMapsApi = require('load-google-maps-api');
const {getDynamicMapApiKey} = require('./google_maps_api_key');
const Fetcher = require('od-modules/utils/fetcher');

function googleMapsLoad() {
    const [language = 'en'] = Odigeo.SessionScope.locale.split('_');
    return loadGoogleMapsApi({
        v: 'weekly',
        key: getDynamicMapApiKey(),
        language: language.toLowerCase(),
        region: 'MA',
        channel: `${Odigeo.SessionScope.brand}_${Odigeo.SessionScope.locale}`,
    });
}

function url() {
    return Odigeo.Settings.getProperty('geoServiceUrlFormatter')('geolocateIp');
}

function loadGoogleMaps() {
    return Fetcher.get(url()).json()
        .then((response) => googleMapsLoad(response.countryCode));
}

function loadGoogleMapsWithAddons(...addOns) {
    return loadGoogleMaps().then((libMap) => {
        return new Promise((resolve) => {
            Odigeo.require(addOns, () => resolve(libMap));
        });
    });
}

module.exports = {loadGoogleMaps, loadGoogleMapsWithAddons};
